module.exports = __webpack_public_path__ + "img/mom.3513b98b.png";